document.addEventListener('DOMContentLoaded', () => {
    // querySelectorAll (not getElementById) in case more than one instance
    // renders on the same page (e.g. a quickbuy card) — getElementById only
    // ever finds the first, silently leaving any other instance's form
    // without a listener and falling through to a real page navigation.
    document.querySelectorAll('#custom-newsletter').forEach(initCustomNewsletter);
});

function initCustomNewsletter(root) {
    const form = root.querySelector('form');
    const promoRow = root.querySelector('#promo-row');
    const showFormButton = root.querySelector('#show-form-button');
    const drawerOuter = root.querySelector('#signup-drawer-outer');
    const emailInput = root.querySelector('#promo-email-input');
    const codeRow = root.querySelector('#code-row');
    const copyButton = root.querySelector('#copy-to-clipboard');
    const submitButton = root.querySelector('#signup-submit');

    // A third-party page script relabels the first `button[type="submit"]` it finds as "Add to Cart" — reassert our label once everything else has run.
    if (submitButton && submitButton.dataset.label) {
        window.addEventListener('load', () => {
            if (submitButton.textContent.trim() !== submitButton.dataset.label) {
                submitButton.textContent = submitButton.dataset.label;
            }
        });
    }

    function expandDrawer() {
        if (!drawerOuter) return;
        // Force a reflow so the transition runs even if a prior script
        // (the inline unlock check) had set `transition: none`.
        drawerOuter.style.transition = '';
        void drawerOuter.offsetHeight;
        drawerOuter.style.gridTemplateRows = '1fr';
    }

    function collapseDrawer() {
        if (!drawerOuter) return;
        drawerOuter.style.gridTemplateRows = '0fr';
    }

    function unlockCode() {
        if (promoRow) promoRow.classList.add('hidden');
        collapseDrawer();
        if (codeRow) {
            codeRow.classList.remove('hidden');
            codeRow.classList.add('flex');
        }
        try {
            sessionStorage.setItem('illusPdpPromoUnlocked', 'true');
        } catch (e) {
            // sessionStorage unavailable (private mode, etc) — the code row
            // still shows for this page view, it just won't persist.
        }
    }

    if (showFormButton) {
        showFormButton.addEventListener('click', (ev) => {
            ev.preventDefault();
            if (promoRow) promoRow.classList.add('hidden');
            expandDrawer();
            if (emailInput) emailInput.focus();
        });
    }

    if (form) {
        form.addEventListener('submit', async (ev) => {
            // Always stop the real page navigation first — a Shopify
            // `{% form 'customer' %}` submit that isn't cancelled here
            // reloads the page at `/contact#...`, which is what makes the
            // product page "disappear".
            ev.preventDefault();

            if (!emailInput || !emailInput.checkValidity()) {
                if (emailInput) emailInput.reportValidity();
                return;
            }

            if (submitButton) submitButton.disabled = true;

            try {
                await fetch(form.action, {
                    method: 'POST',
                    body: new FormData(form),
                    headers: { Accept: 'application/json' },
                });
            } catch (e) {
                // Signup request failed to send — reveal the code anyway, matching the always-show behavior.
            }
            unlockCode();
            if (submitButton) submitButton.disabled = false;
        });
    }

    if (copyButton) {
        copyButton.addEventListener('click', async (ev) => {
            ev.preventDefault();
            const code = root.getAttribute('data-discount-code');
            if (!code) return;

            try {
                await navigator.clipboard.writeText(code);
                // Not `disabled` — the sitewide `button[disabled]` reset
                // forces white text, which is invisible against this row's
                // light pink background.
                copyButton.textContent = 'Copied!';
                clearTimeout(copyButton._revertTimer);
                copyButton._revertTimer = setTimeout(() => {
                    copyButton.textContent = 'Copy';
                }, 2000);
            } catch (e) {
                console.error('Failed to copy: ', e);
            }
        });
    }
}
